export class ExternalTransferOnlyStructureResponseDto {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	public Workfile: string;
}
